import React from "react";
import Button from "components/CustomButtons/Button.jsx";
import firebase, { db, storage } from "firebase/fbConfig.js"

const api = {
    uploadFile({ timeout = 550 }) {
        return new Promise((resolve) => {
            setTimeout(() => {
                resolve()
            }, timeout)
        })
    },
}

class PictureUpload extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            inputValue: '',
            files: [],
            uploaded: [],
            status: 'idle',
        };
        this.handleChange = this.handleChange.bind(this);
        this.loadDocs = this.loadDocs.bind(this);
        this.exploreFiles = this.exploreFiles.bind(this);

    }

    componentDidUpdate(prevProps, prevState) {
        const { status, files } = this.state;

        if (prevProps.del !== this.props.del) {
            const fileObj = files.find(file => file.fileURL === this.props.del);
            if (files.indexOf(fileObj) !== -1) {
                files.splice(files.indexOf(fileObj), 1);
                this.setState({
                    files: files
                });
            };

        }

        if (status === 'idle') return;

        if (status === 'loading') {
            console.log(`Total files: ${files.length}`);
            this.setState({ status: 'idle' })
            this.loadDocs();
        }

        if (status === 'ready') {
            this.props.onAssignPic(this.state.files);
            this.setState({ status: 'idle', files: [] });
        }
    }

    handleChange(e) {
        this.setState({ inputValue: e.target.value })
        e.preventDefault();
        if (e.target.files.length) {
            const arrFiles = Array.from(e.target.files);
            console.log(e.target.files, arrFiles);

            const files = arrFiles.map((file, index) => {
                const fileURL = window.URL.createObjectURL(file);
                console.log({ file, id: index + this.state.files.length, fileURL });
                return { file, id: index + this.state.files.length, fileURL };
            });

            this.setState({
                files: [...this.state.files, ...files],
                status: 'loading'
            });
        }
        this.setState({
            inputValue: ''
        })
    }

    loadDocs() {
        const { files } = this.state;
        console.log(files);
        for (let i = 0; i < files.length; i++) {
            api.uploadFile(files[i])
                .then(() => {
                    const uploaded = this.state.uploaded;
                    uploaded.push(files[i]);
                    this.setState({
                        uploaded: uploaded,
                        status: i === (files.length - 1) ? 'ready' : this.state.status
                    })
                }).catch(err => console.error(err));
        }
    }

    exploreFiles() {
        this.refs.docUploader.click();
    }

    render() {
        return (
            <div>
                <Button
                    color='info'
                    component='div'
                    onClick={this.exploreFiles}
                >
                    UPLOAD DOCUMENT
                        <input type="file" accept="image/jpeg,image/gif,image/png,application/pdf,image/x-eps" ref={'docUploader'} onChange={this.handleChange} style={{ display: 'none' }} multiple />
                </Button>
            </div>
        );
    }
}

export default PictureUpload;



// WEBPACK FOOTER //
// ./src/components/CustomUpload/docUpload.jsx